import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { usePlanPillStateV2 } from './PlanPill.hooks'
import Link from 'next/link'

export const PlanPillV2: FC = () => {
  const { labelText, color, backgroundColor } = usePlanPillStateV2()
  return (
    <Link href={Routes.ACCOUNT}>
      <Box
        height="30px"
        width="max-content"
        cursor="pointer"
        borderRadius="4px"
        backgroundColor={backgroundColor}
        justifyContent="center"
        alignItems="center"
        p="8px"
      >
        <Text fontSize="18px" fontWeight={900} color={color} fontFamily="Centra No2">
          {labelText}
        </Text>
      </Box>
    </Link>
  )
}
